import { useMediaQuery, useTheme } from '@mui/material';
import { setLocalStorageItem } from 'hooks';
import type { FC, ReactElement } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IAuthLayout {
  children: ReactElement<any, any>;
}

const AuthLayout: FC<IAuthLayout> = ({ children }) => {
  const theme: any = useTheme();
  const { i18n } = useTranslation();
  const underSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile375 = useMediaQuery('(max-width:375px)');

  const switchLanguage = (language: string) => {
    i18n.changeLanguage(language);
    setLocalStorageItem('lang', language);
    // setAnchorEl(null);
  };
  return (
    <div
      className="relative flex h-full w-full items-center justify-center overflow-hidden"
      style={{
        // backgroundImage: underSm ? 'none' : `url(${userBG})`,
        backgroundImage: 'linear-gradient(to right, #90BEE6, #3EC8B2)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: underSm ? '100svh' : '100vh',
        boxSizing: 'border-box',
        borderRadius: '24px',
        border: '10px solid #fff',
      }}
    >
      {children}
      <div
        className={`absolute bottom-2 flex w-full justify-between px-4 ${
          isMobile375 ? 'mb-[-20px]' : ''
        }`}
      >
        <p
          className={` ${underSm ? 'ml-[25px]' : 'ml-[30px]'} ${
            underSm ? 'pt-[13px]' : ''
          } text-sm text-[#1A1B25]`}
        >
          © 2025 airadoc GmbH. All rights reserved.
        </p>
        <select
          className="!mr-[30px] !text-sm !text-[#1A1B25]"
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
          }}
          onChange={(e) => switchLanguage(e.target.value)}
        >
          <option value="en">English</option>
          <option value="de">Deutsch</option>
        </select>
      </div>
    </div>
  );
};

export default AuthLayout;
